import { ProtectedAreasOsm } from '@/api/rest/resources/types/protectedAreas';
import { getProxiedMapServerUrl } from '@/utils/mapServer';

export const LANDLER_CAT_TO_OSM_CATEGORY: Record<number, ProtectedAreasOsm> = {
  1: ProtectedAreasOsm.strictly_protected_area,
  2: ProtectedAreasOsm.national_park_natural_monument,
  3: ProtectedAreasOsm.habitat_and_species_management_area,
  4: ProtectedAreasOsm.protected_landscape_and_sustainable_use_area,
  5: ProtectedAreasOsm.indigenous_territory,
  6: ProtectedAreasOsm.no_take_reserve,
  7: ProtectedAreasOsm.highly_protected_mpa,
  8: ProtectedAreasOsm.lightly_protected_mpa,
  9: ProtectedAreasOsm.minimally_protected_mpa,
  10: ProtectedAreasOsm.water_protection_area,
  11: ProtectedAreasOsm.internationally_recognized_area,
  12: ProtectedAreasOsm.cultural_site,
  13: ProtectedAreasOsm.unclassified_marine_area,
  14: ProtectedAreasOsm.unclassified,
} as const;

export type LayerFeature = {
  type: string;
  id: string;
  properties: {
    [key: string]: string | number | null;
  };
};

/**
 * GET /mapserver.landler.io/geoserver/{map_origin}/wms/
 */
export const GET_GEOSERVER_LAYER_FEATURES = getProxiedMapServerUrl(
  'https://mapserver.landler.io/geoserver/{map_origin}/wms',
);
export type GetGeoserverLayerFeaturesPathVariables = { map_origin: string };
export type GetGeoserverLayerFeaturesQueryParams = {
  SERVICE: string;
  VERSION: string;
  REQUEST: string;
  FORMAT: string;
  TRANSPARENT: string;
  QUERY_LAYERS: string;
  LAYERS: string;
  INFO_FORMAT: string;
  X: number;
  Y: number;
  SRS: string;
  WIDTH: number;
  HEIGHT: number;
  BBOX: string;
};
export type GetGeoserverLayerFeaturesSuccessDto = {
  type: string;
  features: LayerFeature[];
};
export type GetGeoserverLayerFeaturesErrorDto = Error;
